import Raven from 'raven-js';
import { useEffect, useMemo, useState } from 'react';

// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'self... Remove this comment to see the full error message
import { getLocationAwareProductPurchaseMotionData } from 'self-service-api/api/getProductPurchaseMotionData';
import withErrorBoundary from '../ErrorBoundary';
import { UI_UPGRADE_BANNER } from '../_core/common/constants/ErrorBoundaryNames';
import { USAGE_LIMIT_BANNER } from '../_core/common/constants/PurchaseMotionLocations';
import { getQueryParam } from '../_core/utils/commMethodOverrides';
import LimitPackBanner from './banner/LimitPackBanner';
import LoadingBanner from './banner/LoadingBanner';
import RemoveBrandingBanner from './banner/RemoveBrandingBanner';
import RemoveBrandingBannerWithBadge from './banner/RemoveBrandingBannerWithBadge';
import UsageLimitBanner from './banner/UsageLimitBanner';
import { fetchValidatedBannerUpgradeConfig } from './fetchValidatedBannerUpgradeConfig';
import { POINT_TYPES, UPGRADE_BANNER_TYPES } from './types';
import { warnArchivedUpgradePointUse } from './utils';
import { jsx as _jsx } from "react/jsx-runtime";
const UIUpgradeBanner = ({
  upgradeKey,
  limit,
  value,
  displayThreshold,
  marginStyle = {},
  'data-test-id': dataTestId,
  showFTS002Variant,
  title
}) => {
  const [fetchedBannerDetails, setFetchedBannerDetails] = useState({
    loading: true,
    error: null
  });
  const displayBannerOverride = getQueryParam('displayUpgradeBanner');
  const [purchaseMotionResponse, setPurchaseMotionResponse] = useState();
  const isValueBelowDisplayThreshold = useMemo(() => {
    return !displayBannerOverride && displayThreshold && value !== undefined && value >= 0 && value < displayThreshold;
  }, [displayThreshold, value, displayBannerOverride]);
  useEffect(() => {
    fetchValidatedBannerUpgradeConfig(upgradeKey).then(({
      upgradeConfig
    }) => {
      if (!upgradeConfig) return;
      if (!Object.keys(UPGRADE_BANNER_TYPES).includes(upgradeConfig.pointType)) {
        throw new Error(`(UIUpgradeBanner) - ${upgradeKey} was declared with an incompatible point type "${upgradeConfig.pointType}"`);
      }
      setFetchedBannerDetails({
        // usage limit banners still need to fetch PMB so stay in a loading state
        loading: upgradeConfig.pointType === USAGE_LIMIT_BANNER,
        error: null,
        data: {
          upgradeConfig
        }
      });
      if (upgradeConfig.status === 'ARCHIVED') {
        warnArchivedUpgradePointUse(upgradeConfig.upgradeKey);
      }
    }).catch(error => {
      Raven.captureException(new Error('Unexpected error when fetching banner upgrade config', {
        cause: error
      }), {
        extra: {
          upgradeKey
        }
      });
      setFetchedBannerDetails({
        loading: false,
        error
      });
    });
  }, [upgradeKey, limit, value, displayThreshold, isValueBelowDisplayThreshold]);

  // Fetch purchase motions for usage limit banners only
  useEffect(() => {
    if (fetchedBannerDetails.data && fetchedBannerDetails.data.upgradeConfig && fetchedBannerDetails.data.upgradeConfig.pointType === POINT_TYPES.USAGE_LIMIT_BANNER) {
      getLocationAwareProductPurchaseMotionData({
        locations: [USAGE_LIMIT_BANNER]
      }).then(response => {
        if (!response) {
          throw new Error('Response is empty');
        }
        setPurchaseMotionResponse(response);
        setFetchedBannerDetails(previousState => Object.assign({}, previousState, {
          loading: false,
          error: null
        }));
      }).catch(error => {
        if (error && error.status !== 0) {
          Raven.captureException(new Error('Unexpected error processing purchase-motions response'), {
            extra: {
              message: error.message
            }
          });
        }
        setPurchaseMotionResponse(null);
        setFetchedBannerDetails(previousState => Object.assign({}, previousState, {
          loading: false,
          error: null
        }));
      });
    }
  }, [fetchedBannerDetails.data]);
  if (isValueBelowDisplayThreshold) {
    return null;
  }
  if (fetchedBannerDetails.loading) {
    return /*#__PURE__*/_jsx(LoadingBanner, {
      marginStyle: marginStyle
    });
  }
  if (fetchedBannerDetails.error || !fetchedBannerDetails.data) {
    return null;
  }
  const {
    upgradeConfig
  } = fetchedBannerDetails.data;
  if (purchaseMotionResponse !== undefined && limit && value !== undefined && value >= 0 && upgradeConfig.pointType === POINT_TYPES.USAGE_LIMIT_BANNER) {
    return /*#__PURE__*/_jsx(UsageLimitBanner, {
      upgradePoint: upgradeConfig,
      limit: limit,
      value: value,
      hasReachedLimit: value >= limit,
      displayBannerOverride: !!displayBannerOverride,
      displayThreshold: displayThreshold,
      marginStyle: marginStyle,
      "data-test-id": dataTestId,
      purchaseMotionData: purchaseMotionResponse
    });
  }
  if (limit && value !== undefined && value >= 0 && upgradeConfig.pointType === POINT_TYPES.LIMIT_PACK_BANNER) {
    return /*#__PURE__*/_jsx(LimitPackBanner, {
      upgradePoint: upgradeConfig,
      limit: limit,
      value: value,
      displayThreshold: displayThreshold,
      displayBannerOverride: !!displayBannerOverride,
      marginStyle: marginStyle,
      "data-test-id": dataTestId
    });
  }
  if (upgradeConfig.pointType === POINT_TYPES.REMOVE_BRANDING_BANNER) {
    if (showFTS002Variant && title) {
      return /*#__PURE__*/_jsx(RemoveBrandingBannerWithBadge, {
        upgradePoint: upgradeConfig,
        marginStyle: marginStyle,
        "data-test-id": dataTestId,
        title: title
      });
    } else {
      return /*#__PURE__*/_jsx(RemoveBrandingBanner, {
        upgradePoint: upgradeConfig,
        marginStyle: marginStyle,
        "data-test-id": dataTestId
      });
    }
  }
  return null;
};
export default withErrorBoundary(UIUpgradeBanner, {
  boundaryName: UI_UPGRADE_BANNER
});